export type EvalRecordType = "course" | "class";

export interface EvalCategoryListQuery {
  course_id: string;
  type?: EvalRecordType;
}

export interface CreateEvalCategoryPayload {
  course_id: string;
  name: string;
  weightage: number;
  max_score: number;
  type: EvalRecordType;
}

export interface EvalListQuery {
  course_id: string;
  student_id: string;
  type?: EvalRecordType;
}

export interface EvalCategoryScorePayload {
  category_id: string;
  score: number;
}

export interface CreateEvalPayload {
  course_id: string;
  type: EvalRecordType;
  student_id: string;
  category_scores: EvalCategoryScorePayload[];
  overall_score: number;
  overall_percentage: number | string;
  remarks: string;
}

/** course_id holds grade id or class offering id depending on type */
export function buildEvalRecordParams(
  resourceId: string,
  type: EvalRecordType = "course"
): { course_id: string; type: EvalRecordType } {
  return { course_id: resourceId, type };
}
